import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  ServiceFour,
  AboutSeven,
  // TeamTwo,
  TestimonialThree,
  CtaOne,
  // BlogFour,
  FooterTwo,
} from "../containers";

const About = () => (
  <Fragment>
    <Seo
      title="About Us"
      description="Learn more about Tech Ayukta, a leading IT Solutions company providing Web Development, App Development, ERP, and IT Consulting."
      keywords="Tech Ayukta, IT Solutions, About Tech Ayukta, Software Company"
      canonical="https://www.techayukta.com/about"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="About Us"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceFour className="space-top space-extra-bottom" />
    <AboutSeven />
    {/* <TeamTwo className="space-top space-extra-bottom"/> */}
    <TestimonialThree className="space-top space-extra-bottom" />
    <CtaOne className="space" />
    {/* <BlogFour className="space-top space-extra-bottom"/> */}
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default About;
